module.exports = __webpack_public_path__ + "static/media/vfriends.a5fd9c8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/vfriends.png
// module id = 358
// module chunks = 0